import { Checkbox, Typography } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Alert } from "@material-ui/lab";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import Workpermit from "components/ltr-request-document//components/Workpermit";
import CompanyInfoSection from "components/ltr-request-document/components/CompanyInfoSection";
import JobSection from "components/ltr-request-document/components/JobSection";
import VisaIssuanceSection from "components/ltr-request-document/components/VisaIssuanceSection";
import ButtonController from "components/request-document/components/ButtonController";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP_LTR,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { LTR_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultJobWorkpermitTable,
  getDefaultRow, mapJobWorkpermitTable
} from "libs/utils/form";
import { get, pick } from "lodash-es";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function LastStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );

  const personalId = get(personalDetail, "personalID", "");
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const organiztionTypeConfig = get(masterData, "organiztionTypeConfig", []);
  const countryConfig = get(masterData, "countryConfig", []);
  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isGovernment = !(
    ConditionType === "Start up" || ConditionType === "Company"
  );

  const workpermit = pick(get(smartform, "workpermit", {}), [
    "workPermitID",
    "workPermitNo",
    "draftId",
    "isRequest",
    "accommodationID",
    "houseNumber",
    "soi",
    "road",
    "addressInThailand",
    "provinceId",
    "districtId",
    "subDistrictId",
    "visatypeId",
    "visaNo",
    "visaIssue",
    "immNo",
    "immPointID",
    "fromCountryID",
    "vehicleID",
    "thaiLastDate",
    "stampEXP",
    "zipcode",
  ]);

  // console.log(smartform);

  const detailList = [
    "WPCompanyRegisterNumber",
    "WPCompanyName",
    "WPCompanyAddress",
    "WPCompanyOfficeNumber",
    "WPCompanyWebsite",
    "WPCompanyProductsServices",
    "WPContractTermType",
    "WPContactPersonInThai",
    "WPContactRelationship",
    "WPContactEmail",
    "WPContactMobile",
    "JobPositionWorkPermit",
    "WPContractYear",
    "WPContractMonth",
    "WPContractOther",
    "WPContractPeriodFrom",
    "WPContractPeriodTo",
    "DesiredWorkingPeriodID",
    "DesiredWorkingPeriodYear",
    "DesiredWorkingPeriodMonth",
    "PeriodStart",
    "PeriodEnd",
    "companyType",
    "emp_idcard_no",
    "emp_fullname",
    "emp_address",
    "emp_province_ddl",
    "emp_district_ddl",
    "emp_subdistrict_ddl",
    "emp_tel",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  // console.log(smartform);

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        OrganiztionTypeConfig: true,
        CountryConfig: true,
        countryEmbassy: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
        JobPositionConfig: true,
        accommodationConfig: true,
        vehicleConfig: true,
        immPointConfig: true,
        companyTypeConfig: true,
        enterprisesConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(
        getSmartFormFieldConfig({
          smartserviceId: smartServiceId,
          smartserviceGroupID: "LTR",
        })
      );
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
          smartserviceGroupID: "LTR",
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          // dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, workpermit, ...restValues } = values;

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values.document);

    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "JobPositionWorkPermit": {
          const jobTable = get(values, `document.${field.smartName}`, []);
          const value = jobTable.filter((v) => !!v.jobTitle);

          return value || null;
        }
        default:
          return get(values, `document.${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      workpermit: workpermit,
      detail: [
        ...(isGovernment
          ? getFieldListConfig.map((field) => ({
            smartName: field.smartName,
            smartId: getSmartId(field),
            partfromId: field.partfromId,
            configsmartId: field.configsmartId,
            linkTable: field.linkTable,
            // value: values[field.smartName] || null,
            value: getValue(field),
          }))
          : []),
      ],
    };
    // console.log(prepareData);
    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({
    visaissuance: yup.object().shape({
      countryId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("Country is required"),
        otherwise: yup.string().nullable(),
      }),
      cityId: yup.string().when("overseas", {
        is: true,
        then: yup.string().nullable().required("City is required"),
        otherwise: yup.string().nullable(),
      }),
      theImmigrationBureauID: yup.string().when("thailand", {
        is: true,
        then: yup
          .string()
          .nullable()
          .required("The Immigration bureau is required"),
        otherwise: yup.string().nullable(),
      }),
      // visaTypeId: yup.string().nullable().required("VisaType is required"),
      // visaExp: yup.string().nullable().required("Expiry date is required"),
    }),
  });

  // const defaultType = get(smartFormFieldConfig, "data.defaultType", []).reduce(
  //   (p, c) => ({ ...p, [c.smartName]: c }),
  //   {}
  // );
  // console.log(defaultType);
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      workpermit: {
        workPermitID: get(workpermit, "workPermitID", ""),
        workPermitNo: get(workpermit, "workPermitNo", ""),
        draftId: get(workpermit, "draftId", ""),
        isRequest: get(workpermit, "isRequest", ""),
        accommodationID: get(workpermit, "accommodationID", null),
        houseNumber: get(workpermit, "houseNumber", ""),
        soi: get(workpermit, "soi", ""),
        road: get(workpermit, "road", ""),
        addressInThailand: get(workpermit, "addressInThailand", ""),
        ProvinceId: get(workpermit, "provinceId", null),
        DistrictId: get(workpermit, "districtId", null),
        SubDistrictId: get(workpermit, "subDistrictId", null),
        visatypeId: get(workpermit, "visatypeId", null),
        visaNo: get(workpermit, "visaNo", ""),
        visaIssue: get(workpermit, "visaIssue", ""),
        immNo: get(workpermit, "immNo", ""),
        immPointID: get(workpermit, "immPointID", null),
        fromCountryID: get(workpermit, "fromCountryID", null),
        vehicleID: get(workpermit, "vehicleID", null),
        thaiLastDate: get(workpermit, "thaiLastDate", ""),
        stampEXP: get(workpermit, "stampEXP", ""),
        Zipcode: get(workpermit, "zipcode", ""),
      },
      visaissuance: {
        visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
        overseas: get(smartform, "visaissuance.overseas", true),
        countryId: get(smartform, "visaissuance.countryId", ""),
        cityId: get(smartform, "visaissuance.cityId", ""),
        thailand: get(smartform, "visaissuance.thailand", false),
        theImmigrationBureauID: get(
          smartform,
          "visaissuance.theImmigrationBureauID",
          null
        ),
        oneStopService: get(smartform, "visaissuance.oneStopService", false),
        eec: get(smartform, "visaissuance.eec", false),
        visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
        visaExp: get(smartform, "visaissuance.visaExp", ""),
      },
      document: {
        companyType: get(detail, "companyType.value", "C"),
        emp_idcard_no: get(detail, "emp_idcard_no.value", ""),
        emp_fullname: get(detail, "emp_fullname.value", ""),
        emp_address: get(detail, "emp_address.value", ""),
        emp_province_ddl: get(detail, "emp_province_ddl.value", ""),
        emp_district_ddl: get(detail, "emp_district_ddl.value", ""),
        emp_subdistrict_ddl: get(detail, "emp_subdistrict_ddl.value", ""),
        emp_tel: get(detail, "emp_tel.value", ""),

        WPCompanyRegisterNumber: get(
          detail,
          "WPCompanyRegisterNumber.value",
          ""
        ),
        WPCompanyName: get(detail, "WPCompanyName.value", ""),
        WPCompanyAddress: get(detail, "WPCompanyAddress.value", ""),
        WPCompanyOfficeNumber: get(detail, "WPCompanyOfficeNumber.value", ""),
        WPCompanyWebsite: get(detail, "WPCompanyWebsite.value", ""),
        WPCompanyProductsServices: get(
          detail,
          "WPCompanyProductsServices.value",
          ""
        ),
        WPContractTermType: get(detail, "WPContractTermType.value", ""),
        WPContactPersonInThai: get(detail, "WPContactPersonInThai.value", ""),
        WPContactRelationship: get(detail, "WPContactRelationship.value", ""),
        WPContactEmail: get(detail, "WPContactEmail.value", ""),
        WPContactMobile: get(detail, "WPContactMobile.value", ""),
        WPContractYear: get(detail, "WPContractYear.value", ""),
        WPContractMonth: get(detail, "WPContractMonth.value", ""),
        WPContractOther: get(detail, "WPContractOther.value", ""),
        WPContractPeriodFrom: get(detail, "WPContractPeriodFrom.value", ""),
        WPContractPeriodTo: get(detail, "WPContractPeriodTo.value", ""),
        DesiredWorkingPeriodID: get(detail, "DesiredWorkingPeriodID.value", ""),
        DesiredWorkingPeriodYear: get(
          detail,
          "DesiredWorkingPeriodYear.value",
          ""
        ),
        DesiredWorkingPeriodMonth: get(
          detail,
          "DesiredWorkingPeriodMonth.value",
          ""
        ),
        PeriodStart: get(detail, "PeriodStart.value", ""),
        PeriodEnd: get(detail, "PeriodEnd.value", ""),
        JobPositionWorkPermit: getDefaultRow(
          detail,
          "JobPositionWorkPermit.value",
          defaultJobWorkpermitTable
        ).map(mapJobWorkpermitTable),
      },
    },
    onSubmit: async (values) => {
      await setSaveDraft(false);
      await callAPISubmit(values);
      await dispatch(setSmartFormStep(LTR_STEP.UPLOAD_DOCUMENT));
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => { };
    formik.handleChange = () => { };
    formik.setFieldValue = () => { };
  }

  // console.log(formik.values.document.JobPositionWorkPermit);

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR  Wealthy Pensioner`}
        />
        {smartform.draftRemark && <Alert severity="error" style={{ marginTop: 18, marginBottom: 18 }}>{smartform.draftRemark}</Alert>}
        <Steper currentStep={2} isLTR stepInfo={REQUEST_DOCUMENT_STEP_LTR} />

        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <VisaIssuanceSection colSpan={4} formik={formik} />
          </Table>
        </TableContainer>

        {formik.values.visaissuance.thailand && (Role === RoleId.Admin || Role === RoleId.Staff) ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 5,
              }}
            >
              <InputLabel style={{ color: "#172B4D", fontWeight: "bold" }}>
                Are you working or do you plan to work in Thailand?
              </InputLabel>
            </div>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formik.values.workpermit.isRequest === true}
                    onChange={() =>
                      formik.setFieldValue("workpermit.isRequest", true)
                    }
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formik.values.workpermit.isRequest === false}
                    onChange={() =>
                      formik.setFieldValue("workpermit.isRequest", false)
                    }
                  />
                }
                label="No"
              />
            </FormGroup>
            {formik.values.workpermit.isRequest ? (
              <>
                <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell colSpan={4}>
                          <Typography
                            variant="h6"
                            className={classes.tableTitle}
                          >
                            Company Information
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <CompanyInfoSection formik={formik} />
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell colSpan={4}>
                          <Typography
                            variant="h6"
                            className={classes.tableTitle}
                          >
                            Job Information
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <JobSection formik={formik} />
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell colSpan={4}>
                          <Typography
                            variant="h6"
                            className={classes.tableTitle}
                          >
                            Address in Thailand
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <Workpermit formik={formik} />
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : null}
          </>
        ) : null}
        <ButtonController
          onClickSaveDraft={async () => {
            await setSaveDraft(true);
            await callAPISubmit(formik.values);
            await dispatch(
              getSmartForm({
                smartserviceId: smartServiceId,
                draftId,
                personalId,
                smartserviceGroupID: "LTR",
              })
            );
          }}
          onClickNext={async () => {
            if (Role !== RoleId.Admin && Role !== RoleId.Staff) {
              await setSaveDraft(true);
              // await formik.handleSubmit();
              await dispatch(
                getSmartForm({
                  smartserviceId: smartServiceId,
                  draftId,
                  personalId,
                  smartserviceGroupID: "LTR",
                })
              );
            }
          }}
          onClickBack={() =>
            dispatch(setSmartFormStep(LTR_STEP.SHOW_FORM_STEP))
          }
          isLTR
        />
      </form>
    </div>
  );
}
